import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter, generatePath } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  Modal,
  Row,
} from "reactstrap"
import {
  getActiveSiteUsers,
  getAllUserResponses,
  getPoll,
  getPollReply,
  getSelectedEvent,
  resetAllUserResponses,
  resetPoll,
  resetPollReply,
} from "store/actions"
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"
import ModalComponent from "components/Modals"
import FeatureResponsesModal from "../featureResponsesModal"
import MobilePreview from "./mobilePreview"
import { TIME_FORMATS, URL_PATHS } from "constants/index"
import moment from "moment"
import UserList from "./userList"

const PollReports = ({
  history,
  match,
  getPoll,
  resetPoll,
  poll,
  pollReply,
  getPollReply,
  resetPollReply,
  getActiveSiteUsers,
  activeSiteUsers,
  vendorId,
  selectedEvent,
  getEvent,
  allUserResponses,
  getAllUserResponses,
  resetAllUserResponses,
}) => {
  const { event_id, feature_id } = match?.params
  useEffect(() => {
    getPoll(feature_id)
    getPollReply({ id: feature_id })
    getAllUserResponses({
      feature: "poll",
      page: 1,
      per_page: 15,
      feature_id: feature_id,
      od: "desc",
    })
    getEvent(event_id)
    return () => {
      resetPoll()
      resetPollReply()
      resetAllUserResponses()
    }
  }, [])

  useEffect(() => {
    if (vendorId) {
      getActiveSiteUsers({ id: vendorId })
    }
  }, [vendorId])

  const [chartData, setChartData] = useState([])
  const [totalPercentage, setTotalPercentage] = useState(0)

  useEffect(() => {
    if (pollReply && poll?.question?.answers) {
      let totalAnswers = 0
      pollReply?.results?.forEach(x => {
        totalAnswers = totalAnswers + x?.total
      })
      setChartData(
        pollReply?.results?.map(res => {
          return {
            total: res?.total,
            answer: poll?.question?.answers?.find(x => x?.id === res?.answer_id)
              ?.answer,
            answer_id: res?.answer_id,
            percentage: ((res?.total / totalAnswers) * 100).toFixed(2),
          }
        })
      )
    }
  }, [pollReply, poll])

  useEffect(() => {
    if (pollReply && pollReply?.results) {
      const totalAnswers = pollReply.results.reduce(
        (acc, v) => acc + v?.total,
        0
      )
      setTotalPercentage(
        activeSiteUsers?.length > 0
          ? ((totalAnswers / activeSiteUsers?.length) * 100).toFixed(2)
          : 0
      )
    }
  }, [pollReply, activeSiteUsers])

  const [selectedAnswer, setSelectedAnswer] = useState(null)
  const [dataToggler, setDataToggler] = useState("number")

  const handleBarClick = data => {
    setSelectedAnswer(data?.payload)
    setResponsesModalIsOpen(true)
  }

  const [responsesModalIsOpen, setResponsesModalIsOpen] = useState(false)
  const [individualAnswersModalIsOpen, setIndividualAnswersModalIsOpen] =
    useState(false)
  const [individualAnswer, setIndividualAnswer] = useState(null)

  const handleOpenIndividualAnswers = item => {
    setIndividualAnswersModalIsOpen(true)
    setIndividualAnswer(item)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PageMetaTags title="Poll Reports" />
          <BreadcrumbTitle
            title={poll?.name || ""}
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Experience Reports",
                link: generatePath(URL_PATHS.EVENT_REPORTS, { id: event_id }),
              },
              { title: "Poll Report" },
            ]}
          />
          <Row className="d-flex justify-content-end">
            <Col xs="auto">
              <SaveButton
                type="button"
                color="light"
                content="Back"
                onClick={() => {
                  history.goBack()
                }}
              />
            </Col>
          </Row>
          {/* <Card className="mt-3">
            <CardBody>
              <Row>
                <Col>
                  <label>
                    # of Users that could take the Poll:{" "}
                    {activeSiteUsers?.length}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <label>
                    % of Users that took the Poll: {totalPercentage}%
                  </label>
                </Col>
              </Row>

              <Row>
                <Col xl={8} className="my-3">
                  <Row className="d-flex justify-content-end">
                    <Col xs="auto">
                      <SaveButton
                        type="button"
                        color={
                          dataToggler === "percentage" ? "primary" : "secondary"
                        }
                        size="sm"
                        content="%"
                        onClick={() => setDataToggler("percentage")}
                      />
                    </Col>
                    <Col xs="auto">
                      <SaveButton
                        type="button"
                        color={
                          dataToggler === "number" ? "primary" : "secondary"
                        }
                        size="sm"
                        content="#"
                        onClick={() => setDataToggler("number")}
                      />
                    </Col>
                  </Row>
                  <Row style={{ height: "500px" }}>
                    <Col>
                      <ResponsiveContainer>
                        <BarChart
                          data={chartData}
                          width={500}
                          height={500}
                          margin={{
                            top: 20,
                            right: 30,
                            left: 20,
                            bottom: 15,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis
                            dataKey="answer"
                            tick={{
                              stroke: "black",
                              strokeWidth: 0.5,
                            }}
                            dy={10}
                            label={{
                              value: "Answers",
                              position: "bottom",
                            }}
                          />
                          <YAxis
                            label={{
                              value: "# of Responses",
                              angle: -90,
                              position: "insideLeft",
                            }}
                            tick={{
                              stroke: "black",
                              strokeWidth: 0.5,
                            }}
                            dx={-10}
                            domain={
                              dataToggler === "number"
                                ? [0, "dataMax"]
                                : [0, 100]
                            }
                            allowDecimals={false}
                          />
                          <Tooltip
                            cursor={{ fill: "rgb(220, 220, 220, 0.5)" }}
                          />
                          <Bar
                            dataKey={
                              dataToggler === "number" ? "total" : "percentage"
                            }
                            name={
                              dataToggler === "number"
                                ? "Number of Responses"
                                : "Percentage"
                            }
                            fill="#556ee6"
                            maxBarSize={100}
                            onClick={handleBarClick}
                          />
                        </BarChart>
                      </ResponsiveContainer>
                    </Col>
                  </Row>
                </Col>
                <Col className="my-3">
                  <MobilePreview
                    bgImage={selectedEvent?.design?.bg_image_url}
                    question={poll?.question?.question}
                    options={poll?.question?.answers}
                    color={selectedEvent?.design?.menu_bg_color}
                    chartType={poll?.chart_type}
                    metrics={poll?.results_metrics}
                    chartData={chartData}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card> */}
          {!!allUserResponses && (
            <UserList
              handleOpenIndividualAnswers={handleOpenIndividualAnswers}
              feature_id={feature_id}
              feature_name={poll?.name}
            />
          )}
        </Container>
      </div>
      <ModalComponent
        title={poll?.name}
        open={individualAnswersModalIsOpen}
        onClose={() => {
          setIndividualAnswersModalIsOpen(false)
          setIndividualAnswer(null)
        }}
        size="lg"
      >
        <Card>
          <span>
            Viewing submission from <b>{individualAnswer?.name}</b> on{" "}
            <b>
              {moment(individualAnswer?.responded_at?.date).format(
                TIME_FORMATS(
                  moment().diff(
                    moment(individualAnswer?.responded_at?.date),
                    "days"
                  )
                ).DATETIME
              )}
            </b>
          </span>
          <ListGroup className="my-3">
            <ListGroupItem>
              <Row>
                <Col>
                  <b>Question</b>
                </Col>
                <Col>
                  <b>Answer</b>
                </Col>
              </Row>
            </ListGroupItem>
            <ListGroupItem>
              <Row>
                <Col>{individualAnswer?.question}</Col>
                <Col>{individualAnswer?.response}</Col>
              </Row>
            </ListGroupItem>
          </ListGroup>
        </Card>
      </ModalComponent>
      <Modal
        style={{ maxWidth: "1600px" }}
        isOpen={responsesModalIsOpen}
        toggle={() => {
          setResponsesModalIsOpen(false)
        }}
        size="xl"
        centered={true}
        scrollable={true}
      >
        <div className="modal-header">
          <button
            type="button"
            onClick={() => {
              setResponsesModalIsOpen(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body" style={{ minHeight: "500px" }}>
          <FeatureResponsesModal
            featureType="poll"
            featureId={poll?.id}
            answerId={selectedAnswer?.answer_id}
            question={poll?.question?.question}
            answer={selectedAnswer?.answer}
            handleClose={() => {
              setResponsesModalIsOpen(false)
            }}
          />
        </div>
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  poll: state.Poll.poll,
  allUserResponses: state.Analytics.allUserResponses,
  pollReply: state.Poll.pollReply,
  vendorId: state.Login.vendorId,
  activeSiteUsers: state.Analytics.activeSiteUsers,
  selectedEvent: state.experiences.selectedEvent,
})

const mapDispatchToProps = dispatch => ({
  getPoll: values => dispatch(getPoll(values)),
  resetPoll: () => dispatch(resetPoll()),
  getPollReply: values => dispatch(getPollReply(values)),
  resetPollReply: () => dispatch(resetPollReply()),
  getActiveSiteUsers: values => dispatch(getActiveSiteUsers(values)),
  getEvent: values => dispatch(getSelectedEvent(values)),
  getAllUserResponses: values => dispatch(getAllUserResponses(values)),
  resetAllUserResponses: () => dispatch(resetAllUserResponses()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PollReports))
